import React from 'react';

export default function CancelIcon() {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>E3CCD0FA-7E3F-4310-AD5C-E4CB931826F2</title>
      <desc>Created with sketchtool.</desc>
      <defs>
        <polygon
          id="path-1"
          points="12.6666667 4.27333333 11.7266667 3.33333333 8 7.06 4.27333333 3.33333333 3.33333333 4.27333333 7.06 8 3.33333333 11.7266667 4.27333333 12.6666667 8 8.94 11.7266667 12.6666667 12.6666667 11.7266667 8.94 8"
        />
      </defs>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icon-/-Action-/-Close-/-Small">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use
            id="Shape"
            fillOpacity="0.5"
            fill="#3A833C"
            xlinkHref="#path-1"
          />
          <g id="Color-/-Stone" mask="url(#mask-2)" fill="#B5B5B5">
            <g transform="translate(-91.000000, -28.000000)" id="#B5B5B5">
              <polygon points="0 0 180 0 180 130 0 130" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/components/CancelIcon.svg.jsx